import { useSyncExternalStore } from 'react';

/**
 * A count of meeting starts and finishes this app session (TMMAPP-0155 item 11): the sidebar's Today
 * block reads its meeting again when it changes, so Start or End on a meeting's session refreshes it
 * without a route change (TMMAPP-0159 §B 6: the session is where a meeting runs). In memory only, never storage.
 */
let version = 0;
const listeners = new Set<() => void>();

/** Call after a meeting's start or end write succeeds. */
export function noteMeetingWrite(): void {
  version += 1;
  for (const listener of listeners) listener();
}

function subscribe(listener: () => void) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}

/** The write count, re-rendering the caller when it changes. */
export function useMeetingWriteVersion(): number {
  return useSyncExternalStore(
    subscribe,
    () => version,
    () => version,
  );
}
